import { ApplicationUser } from '../entities/ApplicationUser';
import { WebClient } from './server/WebClient';

export interface RegisterAccountRequest {
    firstName: string,
    lastName: string,
    email: string,
    password: string
}

export const AuthenticationService = {
    decodeResetPasswordEmail: (email: string) => WebClient.Post.Validated<string>("api/Authentication/DecodeResetPasswordEmail", { email: email }),

    getAuthenticatedUser: () => WebClient.Get<ApplicationUser | null>("api/Authentication/GetAuthenticatedUser"),

    register: (request:RegisterAccountRequest) => 
        WebClient.Post.Validated<ApplicationUser>("api/Authentication/Register", request),

    resetPassword: (email: string, password: string, confirmPassword: string, code: string) => 
        WebClient.Post.Validated<ApplicationUser>("api/Authentication/ResetPassword", { email, password, confirmPassword, code }),

    sendResetPasswordEmail: (email: string, redirect?:string) => 
        WebClient.Post.Validated<null>("api/Authentication/SendResetPasswordEmail", { email, redirect }),

    signIn: (email: string, password: string, rememberMe: boolean) => 
        WebClient.Post.Validated<ApplicationUser>("api/Authentication/SignIn", { email, password, rememberMe }),

    signOut: async () =>  {
        const response = await WebClient.Get<string>("api/Authentication/SignOut");
        if (response.success) {
            return response.data;
        }
        return '';
    },

    refreshUser: () => WebClient.Get<ApplicationUser | null>("api/Authentication/RefreshUser"),
}